import { MethodePrelevementEau } from './methode-prelevement-eau';
import { LocalisationStation } from '../Shared/localisation-station';
import { GPSPosition } from '../GPS-position';
import { WaterMeasure } from './water-measure';

export class WaterProcess {

    Code: string;
    GroupementPrelevement: boolean;
    HauteurMoyenneEauEstimee: number;
    Profondeur: number;
    NombreFlacons: number;
    Methode: MethodePrelevementEau;
    NumeroAppareil: string;
    TemperatureGlaciere: number;
    DistanceMesure: number;
    Position: GPSPosition = new GPSPosition();
    Measures: WaterMeasure[] = [];

    static mapFromJSON(json): any {
        const w = new WaterProcess();

        w.Code = json.code;
        w.GroupementPrelevement = json.groupementPrelevement;
        w.HauteurMoyenneEauEstimee = json.hauteurMoyenneEauEstimee;
        w.Profondeur = json.profondeur;
        w.NombreFlacons = json.nombreFlacons;
        w.Methode = json.methode;
        w.NumeroAppareil = json.numeroAppareil;
        w.TemperatureGlaciere = json.temperatureGlaciere;
        w.DistanceMesure = json.distanceMesure;

        if (json.position) {
            w.Position = GPSPosition.mapFromJSON(json.position);
        }

        if (json.measures) {
            w.Measures = json.measures.map(jsonItem => WaterMeasure.mapFromJSON(jsonItem));
        }
        return w;
    }
}
